import theme from '@styles/theme';
export default {
  paginationContainer: {
    position: 'absolute',
    top: '50%',
    right: ['10px', '10px', '18px', '18px', '34px'],
    transform: 'translateX(-50%)',
    display: 'flex',
    flexFlow: 'column wrap'
  },
  paginationBlock: (isActive: boolean) => ({
    height: '9px',
    width: '6px',
    mb: '8px',
    background: isActive ? theme.rawColors.darkGrey700 : theme.rawColors.lightGrey500,
    transition: 'background-color 0.2s ease-in-out'
  })
};